import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { postAuthPath } from '../onboarding/destination';

/** Requires a logged-in user with completed onboarding and an active subscription. */
export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-gray-400">
        {t('common.loading')}
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!user.onboardingCompleted || !user.hasActiveAccess) {
    return <Navigate to={postAuthPath(user)} replace />;
  }
  return <Outlet />;
}
